<div class="background-cover"></div>
<div class="profile-container payment-container add-new-modal">
  <div class="column-0">
    <div class="settings-section selections">
      <label class="section-label">{{
        'labels.addingNewBankAccountDetails' | translate
      }}</label>

      <div class="profile-form">
        <ops-input
          [label]="'labels.shortName' | translate"
          formName="bankAccount.shortName"
          [value]="bankAccount.shortName"
          mandatory="true"
          (changed)="onValueChange($event, 'shortName')"
          (validationError)="onErrorHandler($event, 'shortName')"
          type="text"
        ></ops-input>

        <ops-input
          [label]="'labels.description' | translate"
          mandatory="true"
          formName="bankAccount.description"
          [value]="bankAccount.description"
          (changed)="onValueChange($event, 'description')"
          (validationError)="onErrorHandler($event, 'description')"
          type="text"
        ></ops-input>

        <ops-input
          [label]="'labels.bank' | translate"
          mandatory="true"
          formName="bankAccount.bankName"
          [value]="bankAccount.bankName"
          (changed)="onValueChange($event, 'bankName')"
          (validationError)="onErrorHandler($event, 'bankName')"
          type="text"
        ></ops-input>

        <ops-input
          [label]="'labels.address' | translate"
          mandatory="true"
          formName="bankAccount.address"
          [value]="bankAccount.address"
          (changed)="onValueChange($event, 'address')"
          (validationError)="onErrorHandler($event, 'address')"
          type="text"
        ></ops-input>

        <ops-calendar
          [label]="'labels.startDate' | translate"
          mandatory="true"
          (dateChanged)="onValueChange($event, 'startDate')"
          formName="bankAccount.startDate"
          [date]="bankAccount.startDate"
        ></ops-calendar>

        <ops-input
          [label]="'labels.bankBranchNo' | translate"
          mandatory="true"
          formName="bankAccount.branchName"
          [value]="bankAccount.branchName"
          (changed)="onValueChange($event, 'branchName')"
          (validationError)="onErrorHandler($event, 'branchName')"
          type="text"
        ></ops-input>

        <ops-input
          [label]="'labels.bankSwift' | translate"
          mandatory="true"
          formName="bankAccount.SWIFT"
          [value]="bankAccount.SWIFT"
          (changed)="onValueChange($event, 'SWIFT')"
          (validationError)="onErrorHandler($event, 'SWIFT')"
          type="text"
        ></ops-input>

        <ops-input
          [label]="'labels.accountNumberIban' | translate"
          mandatory="true"
          formName="bankAccount.IBAN"
          [value]="bankAccount.IBAN"
          (changed)="onValueChange($event, 'IBAN')"
          (validationError)="onErrorHandler($event, 'IBAN')"
          type="number"
        ></ops-input>

        <ops-select
          rotateDropdownDirection="'true'"
          [options]="mainCurrencies"
          mandatory="true"
          [defaultSelected]="bankAccount.currencyCode"
          [formName]="bankAccount.currencyCode"
          [label]="'labels.currencyCode' | translate"
          (changed)="onSelectChangeForBA($event, 'currencyCode')"
        ></ops-select>

        <ops-input
          [label]="'labels.correspondentBank' | translate"
          formName="bankAccount.correspondentBank"
          [value]="bankAccount.correspondentBank"
          (changed)="onValueChange($event, 'correspondentBank')"
          (validationError)="onErrorHandler($event, 'correspondentBank')"
          type="text"
        ></ops-input>
        <ops-input
          [label]="'labels.correspondentBankSwift' | translate"
          formName="bankAccount.correspondentSWIFT"
          [value]="bankAccount.correspondentSWIFT"
          (changed)="onValueChange($event, 'correspondentSWIFT')"
          (validationError)="onErrorHandler($event, 'correspondentSWIFT')"
          type="text"
        ></ops-input>

        <ops-calendar
          invertDirection="true"
          [label]="'labels.accountBalanceStartDate' | translate"
          (dateChanged)="onValueChange($event, 'startingBalanceDate')"
          formName="bankAccount.startingBalanceDate"
          [date]="bankAccount.startingBalanceDate"
        ></ops-calendar>

        <ops-input
          [label]="'labels.accountBalanceStartAmount' | translate"
          formName="bankAccount.startingBalance"
          [value]="bankAccount.startingBalance"
          (validationError)="onErrorHandler($event, 'startingBalance')"
          (changed)="onValueChange($event, 'startingBalance')"
          decimalValue="true"
          type="text"
        ></ops-input>

        <ops-checkbox
          [label]="'labels.isFavorite' | translate"
          [formName]="bankAccount.isFavorite"
          [value]="bankAccount.isFavorite"
          (changed)="onValueChange($event, 'isFavorite')"
        ></ops-checkbox>
      </div>

      <div class="create-actions">
        <button class="cancel-button" (click)="closeModalHandle()">
          {{ 'labels.cancel' | translate }}
        </button>
        <button
          class="save-button"
          [class.disabled]="!isValid"
          (click)="saveNewBankAccount()"
          [disabled]="!isValid"
        >
          {{ 'labels.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
